module.exports = "#exp-tab-name{\r\n    margin-top: 56px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/selectable-tabs/expert-screen-components/expert-trim/expert-trim.component.css
// module id = ./src/app/components/selectable-tabs/expert-screen-components/expert-trim/expert-trim.component.css
// module chunks = main